// extracted by mini-css-extract-plugin
export var cls1 = "index-module--cls1--vPUEM";
export var cls2 = "index-module--cls2--frJSy";
export var cls3 = "index-module--cls3--CtG-R";
export var section = "index-module--section--wJnWV";